import Office from "../Office";

describe("Office model", () => {
  test("belongsTo relations", () => {
    expect(Office.belongsTo.map(relation => relation.name)).toMatchSnapshot();
  });
});
